import { useCallback } from 'react';
import { humanizeError, toFriendlyMessage } from '@/utils/errorMessage';
import { useNotificationContext } from './NotificationProvider';

export function useNotify() {
  const { enqueue } = useNotificationContext();

  // success/info are app-authored copy; the guard is a safety net so a raw backend string can never leak.
  const success = useCallback((msg: string) => enqueue(toFriendlyMessage(msg, 'Done.'), 'success'), [enqueue]);
  const info = useCallback((msg: string) => enqueue(toFriendlyMessage(msg, 'Please try again.'), 'info'), [enqueue]);
  const error = useCallback(
    (err: unknown, fallback = 'Something went wrong. Please try again.') => {
      // Developers see the full technical error in the console; users only see the friendly message.
      console.error('[API error]', err);
      enqueue(humanizeError(err, fallback), 'error');
    },
    [enqueue],
  );

  return { success, info, error };
}
